import { styled } from "@mui/material";
import React from "react";

const StyledCardTitle = styled("h1")`
  font-family: Oswald;
  font-size: 32px;
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: -0.25px;
  text-align: left;
  margin-right: 10px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const StyledHeaderContainer = styled("div")`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const StyledStartContainer = styled("div")`
  display: flex;
  justify-content: flex-start;
`;

function Header({ roteiro }) {
  return (
    <StyledHeaderContainer>
      <StyledStartContainer>
        <StyledCardTitle>{roteiro}</StyledCardTitle>
      </StyledStartContainer>
    </StyledHeaderContainer>
  );
}

export default Header;
